import {c_gradient_reds} from '../a-Graphic/Colors';


// ----- places

export const p_size_1 = 12
export const p_size_2 = 18
export const p_size_3 = 24
export const p_size_4 = 30

// ------ routes

export const r_size_1 = 2.5

// ------ white zones

export const wz_size = 20
export const wz_color_limit1 = c_gradient_reds[1]
export const wz_color_limit2 = c_gradient_reds[3]
